<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Reminder
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Label</p>
            <input id="reminder-label" type="text" name="name" 
              :value="reminder.label" :disabled="! canEdit"/>
          </div>
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Status</p>
            <select id="reminder-status" name="status">
              <option v-for="(statusDisplay, status) in statuses " 
                :selected="statusDisplay==reminder.status? 'selected' : ''"
                :value="status" :disabled="! canEdit" >
                {{ statusDisplay }}
              </option>
            </select>
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Days Before</p>
            <input id="reminder-days-before" type="number" name="days-before" 
              :value="reminder.days_before" :disabled="! canEdit"/>
          </div>
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Days After</p>
            <input id="reminder-days-after" type="number" name="days-after" 
              :value="reminder.days_after" :disabled="! canEdit" />
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Description</p>
            <input id="reminder-description" type="textarea" name="description" 
              :value="reminder.description" :disabled="! canEdit" />
          </div>
        </div>
      </div>
      <div class="card-section sub-section" v-if="canEdit">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitReminder">Update</btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import store from '../../store.js';
import DetailCard from '../DetailCard';
import DetailListCard from '../DetailListCard';
import Popups from '../Popups';
import constants from '../../constants.js';
import { bus } from '../../main';

export default {
  data () {
      return {
        statuses: [],
        message: {type: 'warning', title: 'Reminder'},
      };
  },
  computed: {
    ...mapState({
      // Extract things like this out into a Mixin
      reminder: function(state) {
        return state.reminders.filter((o) => o.id == this.$route.params.id)[0];
      },

      layout: function(state) {
        console.log("Layout: ",state.viewLayouts['reminder-detail'])
        const layout =  store.state.viewLayouts['reminder-detail']
        if (layout !== undefined)
          return layout[0]
        return layout
      },
      canEdit: function(route){
        return store.getters.hasPerm('change_reminder');
      },
    }),
    ...mapGetters([
      'getSelectedReminder',
      'getSelectedReminderList',
    ]),
    canEdit: function(rout){
      return store.getters.hasPerm('change_indicator')
    }
  },

  mounted: function() {
    let _this = this;
    store.dispatch('fetchReminderStatuses').then((response) => {
      console.log(`This is the fetchReminderStatuses response n\n ${response}`);
      _this.statuses = response
    })
  },

  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },

    redirect: function(action) {
      if (action == 'success') this.$router.push('/reminders');
    },

    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
      this.redirect(value.type)
    },


    actionReminder: async function(data, action) {
      let failed = constants.message[action].failed;
      let success = constants.message[action].success;
      let response = await store.dispatch('updateSelectedReminder', { reminder: data });

      if(response === 'success' || response != undefined){
        this.message.type = 'success';
        this.message.content = success;
      } else {
        this.message.type = 'warning';
        this.message.content = failed;
      }

      this.showPopup(this.message, 'notification');
    },


    confirmAction: function(data, action) {
      this.$confirm({
          title: 'Confirm Action',
          content: constants.message[action].action,
        }).then(() => {
          this.actionReminder(data, action)
          }).catch(() => {
            this.$notify('Request has been cancelled.')
          });
    },

    submitReminder: function () {
      this.reset();

      //form field names
      let label = $("#reminder-label").val();
      let status = $("#reminder-status option:selected").val();
      let days_before = $("#reminder-days-before").val();
      let days_after = $('#reminder-days-after').val();
      let description = $('#reminder-description').val();

      if(label.length < 1) {
        this.errors.push('A label is required!');
      }

      if(status.length < 1) {
        this.errors.push('A status is required!');
      }

      if(days_before.length < 1) {
        this.errors.push('Days before is required!');
      }

      if(days_after.length < 1) {
        this.errors.push('Days after is required!');
      }

      if(description.length < 1) {
        this.errors.push('A description is required!');
      }

      let data = {'label': label,
                  'status': status,
                  'days_before': days_before,
                  'days_after': days_after,
                  'description': description,
                  'id':this.$route.params.id};

      if(this.errors.length > 0) { this.showPopup({'content': this.errors }, 'alert'); }
      else { this.confirmAction(data, 'update'); }
    },


  },

  components: {
    DetailCard,
    DetailListCard,
    Popups
  },

  beforeRouteEnter (to, from, next){
    let id = to.params.id;
    store.dispatch('fetchSelectedReminder', {id});
    next();
  }
};
</script>

<style lang="scss">
@import "../../css/constants";


/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;
  
  i { 
    cursor: pointer;
    display: none; 
    font-size: 1.1em; 
    margin-top: -4px; 
    vertical-align: middle; 
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);
    
    &:hover {
      color: #f1f1f1;
    }
  }
}

.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-title {
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
  input{
    width: 100%;
  }
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
  
  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
    }
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px;  }
    }
  }

  @media only screen and (max-width: 467px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px; }
    } 
  }

</style>



// WEBPACK FOOTER //
// src/components/reminder/ReminderDetail.vue